module.exports = __webpack_public_path__ + "img/s2-2.de9d0203.jpg";